$(function() {
    cartJSevent();
    onloadProductGallerySticky();
}); 

onloadProductGallerySticky = () => {
    if ($('.jsc-product-gallery-sticky').length > 0) {
      var navHeight = $('header').innerHeight();
      $('.jsc-product-gallery-sticky').css('top', navHeight + 'px');
    }
}

selectDeskAddon = (e) => {

    if ($(e).closest('.jsc-deskaddon-quick-buy-drawer').length) {
      event.preventDefault();
 
      var qb_id = $(e).closest('quick-buy-drawer').attr('id');
      var qb_col = $(e).closest('quick-buy-drawer').attr('addon-collection');
      var qb_vid = $(e).closest('form').find('[name="id"]').val();

      $(e).closest('quick-buy-drawer').removeAttr('open');
      var target_card = $('#add-on-section-'+qb_col).find('product-list').find('product-card[aria-controls-backup="'+qb_id+'"]');

      target_card.addClass('selected-addon');
      target_card.removeAttr('aria-controls');
      target_card.attr('data-vid',qb_vid);
    }
}

openAddonPopup = (e) => {
    var this_card = $(e);
    var qb_id = this_card.attr('aria-controls-backup'); 

    if (this_card.hasClass('selected-addon')) {

        this_card.removeClass('selected-addon');
        setTimeout(() => {
          this_card.attr('aria-controls', qb_id);
        }, 500);   
    }
}

toggleAddon  = (e) => {
    var addon_product = $(e);
    addon_product.toggleClass('selected-addon');
}

addBundleDesk = (e) => {
    event.preventDefault();
    // Main product
    var bundleID = '';
    var selectedDropdownIDs = '';
    var $this = $(e);
    var jsonObj = [];
    var mainProd = {};
    var mainProp = {};

    var mainProdVid = parseInt($this .closest('form').find('[name="id"]').val());
    var mainProdQty = parseInt($('.__jsc-var-qty').find('input').val());
    var vendorName = $this.closest('form').find('[name="properties[_Vendor]"]');

    var grommetCover = $('input[name="grommet-cover"]:checked').val();

    var grommetHole = $('input[name="grommet-hole"]:checked').map(function() {
        return this.value;
    }).get().join(', ');

    
        // Table leg products
        $('.jsc__table-leg-dropdown-list x-listbox').each(function() {
            var tleg_Prop = {};
            var dropdownTitle = $(this).attr('data-title');  
            var selectedDropdownVal = $(this).find('button[aria-selected="true"]').val();
            var selectedDropdownID = parseInt($(this).find('button[aria-selected="true"]').attr('variant-id'));
            selectedDropdownIDs = selectedDropdownIDs + '-' + selectedDropdownID;
            var tleg_vendor = $(this).find('button[aria-selected="true"]').attr('data-vendor');

            mainProp[dropdownTitle] = selectedDropdownVal;
            tleg_Prop['id'] = selectedDropdownID;
            tleg_Prop['quantity'] = 1;
            if (tleg_vendor != undefined) {
                tleg_Prop['_Vendor'] = tleg_vendor;
            }
            jsonObj.push(tleg_Prop);
        });  

        // Desk addon products
        $('.jsc-customise-desk-addons .product-card.selected-addon').each(function() {
            var addonsProd = {};
            var addonsProp = {};
            var addon_vid = $(this).attr('data-vid');
            var addon_vendor = $(this).attr('data-vendor');

            addonsProd['id'] = addon_vid;
            addonsProd['quantity'] = 1;
            if (addon_vendor != undefined) {
                addonsProp['_Vendor'] = addon_vendor;
            }
            addonsProd['properties'] = addonsProp;
            jsonObj.push(addonsProd);
        });

    // Main product obj  
    mainProd['id'] = mainProdVid;
    mainProd['quantity'] = mainProdQty;

    // Create bundleID using mainProdVid and selectedDropdownID
    bundleID = mainProdVid + '-' + selectedDropdownIDs;
    mainProp['_BundleId'] = bundleID;
    if (vendorName.length > 0) {
        var mainProdVendor = vendorName.val();
        mainProp['_Vendor'] = mainProdVendor;
    }

    mainProp['Include Grommet Cover'] = grommetCover;

    if (grommetCover == 'Yes'){
        mainProp['Grommet Hole Placement'] = grommetHole; 
    }  
    mainProd['properties'] = mainProp; 
    jsonObj.push(mainProd);
    // console.log(selectedDropdownIDs,'selectedDropdownIDs');
    // console.log(jsonObj,'jsonObj');
    addItems(jsonObj);
}

$('input[name="grommet-hole"]').on('change', function() {
    // Get the value of the selected radio button
    var selectedValue = $(this).val();
    $('.variant-picker__option.hole variant-option-value').text(selectedValue);
    console.log('Selected value:', selectedValue);

});

$('input[name="grommet-cover"]').on('change', function() {
    // Get the value of the selected radio button
    var selectedValue = $(this).val();
    $('.variant-picker__option.cover variant-option-value').text(selectedValue);
    if (selectedValue == 'No'){
        $('.variant-picker__option.hole').hide();
    }else{
        $('.variant-picker__option.hole').show();
    }
    console.log('Selected value:', selectedValue);

});

selectTableLeg = (evt) => {
    var $this = $(evt);
    var selectedValue = $this.val();
    $this.parent().find('button').removeAttr('aria-selected');
    $this.closest('.table-leg__option-info').find('span').text(selectedValue);
    $this.closest('fieldset').find('.variant-picker__option-info').children().find('variant-option-value').text(selectedValue);
    $this.attr('aria-selected','true');
}

cartJSevent = () =>{  
    $(document).on('cart.requestStarted', function(event, cart) {
        var $html = `<div class="jsc-page-loading">
                      <div class="jsc-spinner-container">
                        <div class="jsc-spinner"></div>
                      </div>
                    </div>`;
        $('body').prepend($html);
    });
  
    $(document).on('cart.requestComplete', function(event, cart) {
        $('.jsc-page-loading').remove();
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        var headerID = $('.shopify-section--header').attr('id').replace('shopify-section-','').replace(' ','');
        var headerIDpath = "?sections=" + $('.shopify-section--header').attr('id').replace('shopify-section-','').replace(' ','');
        fetch(window.location.pathname + headerIDpath)
        .then(res => res.json())
        .then((restext) => {
          $('.shopify-section--header').children().remove();
          $('.shopify-section--header').html(restext[headerID]);
        });
    });
}

addItems = (jsonObj) => {
    CartJS.addItems(jsonObj,
        {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            // console.log('success')
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus);
        }
    });
}